import React from 'react';
import "../../components/InputField/style.css";
import { useTranslation } from '../../store/context/TranslationContext';
import PreviousValue from "./PreviousValue";
import { buildAutomationChildTestId, resolveAutomationTestId } from './testId';

const CustomTextArea = ({
    id,
    labelStyle,
    placeholder,
    value,
    onChange,
    onCommit,
    error,
    showErr,
    label,
    className,
    required,
    isDisabled,
    prevValue,
    rows
}) => {
    const { t } = useTranslation();
    const fieldTestId = resolveAutomationTestId(id, label);
    return (
        <div className={className} style={{ marginTop: 10 }} data-testid={fieldTestId}>
            {label && (
                <label
                    data-testid={buildAutomationChildTestId(fieldTestId, "label")}
                    style={{
                        ...labelStyle,
                        margin: "0px 0px 10px 5px",
                        fontWeight: "500",
                        textAlign: "left",
                        fontSize: 16
                    }}
                >
                    {t(label)}
                    {required ? <font color="red">*</font> : ""}
                </label>
            )}
            <div className='mx-1'>
                <textarea
                    id={id}
                    data-testid={buildAutomationChildTestId(fieldTestId, "input")}
                    disabled={isDisabled}
                    className={`fvi_text_area w-100 ${prevValue?.has ? "is-changed" : isDisabled ? "is-disabled" : ""}`}
                    placeholder={t(placeholder)}
                    value={value}
                    onBlur={(e) => {
                        const nextValue = e.target.value.trim();
                        onChange(nextValue);
                        onCommit?.(nextValue);
                    }} /* to remove trailing spaces */
                    onChange={(e) => onChange(e.target.value)}
                    rows={rows ?? 4}
                />
                {showErr && error && (
                    <div className="inputfield__error" data-testid={buildAutomationChildTestId(fieldTestId, "error")}>
                        {error}
                    </div>
                )}
                <PreviousValue
                    show={prevValue?.has}
                    value={prevValue?.value}
                    testId={buildAutomationChildTestId(fieldTestId, "previous")}
                />
            </div>
        </div>
    )
};

export default CustomTextArea;
